'use client';
import React from 'react';

import ImageSB, { ImageSBProps } from '@/components/atoms/image/ImageSB';
import { BlockComponentModel } from '@/components/cms/types/blok-component';

import {
  BlockHeader,
  BlockHeaderContent,
} from '@/features/utils/BlockHeaderContent';
import { BlockWrapper } from '@/features/utils/BlockWrapper';

import { ImageBlock, ImageBlockProps } from '.';

interface ImageBlockStrapiProps {
  header: BlockHeader;
  image: ImageSBProps;
  isExpandable: ImageBlockProps['isExpandable'];
}

export const ImageBlockStrapi = ({
  block,
  ...rest
}: BlockComponentModel<ImageBlockStrapiProps>) => {
  const { header, image, isExpandable } = block;

  return (
    <BlockWrapper
      data-tracker-component='image-block'
      {...rest}
      theme={header?.theme?.themeKey}
    >
      <BlockHeaderContent {...header}>
        <ImageBlock
          renderImage={(props) => (
            <ImageSB
              block={image}
              inner={{
                ...props,
                classNames: {
                  image: 'w-full rounded-xl',
                },
              }}
            />
          )}
          isExpandable={isExpandable}
        />
      </BlockHeaderContent>
    </BlockWrapper>
  );
};
